import { useQuery } from '@tanstack/react-query'
import { request } from '../api/fancaps'

interface CacheStats {
  cache_exists: boolean
  total_images: number
  total_size: number
  size_human: string
  cache_directory: string
  id_range?: {
    min: number
    max: number
    sample_ids: number[]
  }
}

export function useCacheStats() {
  const { data: cacheStats, isLoading, error } = useQuery({
    queryKey: ['cache-stats'],
    queryFn: async (): Promise<CacheStats> => {
      return await request<CacheStats>('/images/cache-stats')
    },
    staleTime: 60 * 1000, // 1分钟缓存
    retry: 2,
  })

  return {
    cacheStats,
    isLoading,
    error
  }
}